<template>
  <Modal size="lg">
    <div class="modal-header">{{ "purchase_order" | translate }}</div>
    <div class="modal-body">
      <div class="alert alert-warning" v-if="validationError">
        {{ validationError }}
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "vendor" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="purchaseOrderItem.vendor"
            :placeholder="'vendor' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "order_num" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="purchaseOrderItem.orderNumber"
            :placeholder="'order_num' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "quantity" | translate }}</div>
        <div class="col-9">
          <input
            type="number"
            class="form-control"
            v-model.number="purchaseOrderItem.quantity"
            :placeholder="'quantity' | translate"
          />
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "amount" | translate }}</div>
        <div class="col-6 relative">

          <div class="input-group">
            <input
              type="number"
              class="form-control"
              v-model.number="purchaseOrderItem.amount"
              :placeholder="'amount' | translate"
            />
            <div class="input-group-append">
              <button class="btn btn-outline-success" type="button"
                      @click="calculateTotal" 
              >
                <i class="fa fa-fw fa-calculator"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-3">
          <currency-picker
            class="form-control"
            v-model="purchaseOrderItem.currency"
          ></currency-picker>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-3">{{ "comment" | translate }}</div>
        <div class="col-9">
          <input
            type="text"
            class="form-control"
            v-model="purchaseOrderItem.comment"
            :placeholder="'comment' | translate"
          />
        </div>
      </div>

      <part-transaction-list
        :transactions="purchaseOrderItem.payments"
        :currency="purchaseOrderItem.currency"
        :entity="'payment' | translate"
        :total="purchaseOrderItem.amount"
      ></part-transaction-list>
    </div>

    <div class="modal-footer">
      <button class="btn btn-secondary" @click="cancel">
        {{ "cancel" | translate }}
      </button>
      <button class="btn btn-primary" @click="save">
        {{ "save" | translate }}
      </button>
    </div>
  </Modal>
</template>

<script>
import _ from "lodash";
import PartTransactionList from "./PartTransactionList";
import almostEqual from "@/lib/almostEqual";
export default {
  props: ["editingItem"],
  data() {
    return {
      validationError: null,
      purchaseOrderItem: {
        currency: null,
        vendor: null,
        orderNumber: null,
        quantity: null,
        amount: null,
        payments: [
          {
            account: null,
            amount: null,
            currency: null
          }
        ],
        comment: null,
        timestamp: new Date().getTime()
      }
    };
  },
  created() {
    if (this.editingItem) {
      this.purchaseOrderItem = _.cloneDeep(this.editingItem);
    }
  },
  methods: {
    cancel() {
      this.$emit("dismiss");
    },
    save() {
      let item = this.purchaseOrderItem;
      this.assert(item.currency, "currency is required");
      this.assert(item.vendor, "vendor is required");
      this.assert(item.quantity, "quantity is required");
      this.assert(item.amount, "amount is required");
      this.assert(item.payments && item.payments.length, "payment is required");
      this.assert(
        almostEqual(
          item.payments.reduce(
            (sum, p) => (p.amount ? p.amount + sum : sum),
            0
          ),
          item.amount
        ),
        "payment sum shall equal total amount"
      );

      this.$emit("close", this.purchaseOrderItem);
    },
    assert(value, message) {
      if (!value) {
        this.validationError = message;
        throw new Error("validation failed: " + message);
      }
    },
    calculateTotal() {
      if (!this.purchaseOrderItem.payments) {
        this.purchaseOrderItem.amount = 0 
        return
      }
      
      let sum = this.purchaseOrderItem.payments.reduce((preSum, item) => preSum + item.amount, 0)
      this.purchaseOrderItem.amount = sum
    }
  },
  components: { PartTransactionList }
};
</script>
